import { Topic } from '../../types/Topic';
import { calculateMatchScore } from '../../utils';

type SearchedValue = { fullTerm: null | string; splitTerm: null | string[] };

export const sortTagsBySearchRelevance = (
    topics: Topic[],
    searchTerm?: SearchedValue,
    searchTopic?: SearchedValue
) => {
    if ((!searchTerm?.fullTerm && !searchTopic?.fullTerm) || topics.length <= 1)
        return topics.map((t) => t.title);
    const term = searchTerm?.fullTerm ?? searchTopic?.fullTerm;

    const topicsScored = topics.map((topic) => ({
        ...topic,
        score: {
            de: calculateMatchScore(topic.title, term as string)
        }
    }));

    const toSort = [...topicsScored];

    const tags = toSort
        .sort((a, b) => {
            if (a.score.de > b.score.de) return -1;
            else if (a.score.de < b.score.de) return 1;
            else return 0;
        })
        .map(({ title }) => title);

    return tags;
};
